import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard, Users, ShoppingBag, Package,
  BarChart3, ShieldCheck, Truck, Tag, Star, FileText, X, Percent, Phone,
  Image as ImageIcon
} from 'lucide-react';
import { useAuth } from '../context/AuthContext';


const navItems = [
  { to: '/dashboard',  icon: LayoutDashboard, label: 'Dashboard',  section: 'MAIN' },
  { to: '/sellers',    icon: Users,           label: 'Sellers',    section: 'MANAGEMENT' },
  { to: '/customers',  icon: ShieldCheck,     label: 'Customers',  section: 'MANAGEMENT' },
  { to: '/orders',     icon: ShoppingBag,     label: 'Orders',     section: 'MANAGEMENT' },
  { to: '/products',   icon: Package,         label: 'Products',   section: 'MANAGEMENT' },
  { to: '/categories', icon: Tag,             label: 'Categories', section: 'MANAGEMENT' },
  { to: '/coupons',    icon: Percent,         label: 'Coupons',    section: 'MANAGEMENT' },
  { to: '/delivery',   icon: Truck,           label: 'Delivery',   section: 'MANAGEMENT' },
  { to: '/reviews',    icon: Star,            label: 'Reviews',    section: 'MANAGEMENT' },
 { to: '/banners', icon: ImageIcon, label: 'Banners', section: 'MANAGEMENT' },
  { to: '/terms',      icon: FileText,        label: 'Terms & Conditions', section: 'SETTINGS' },
  { to: '/contact-details', icon: Phone,      label: 'Contact Details', section: 'SETTINGS' },
  { to: '/analytics',  icon: BarChart3,       label: 'Analytics',  section: 'REPORTS' },
];

export default function Sidebar({ isOpen, onClose }) {
  const { user } = useAuth();
  let lastSection = '';

  return (
    <aside className={`sidebar${isOpen ? ' sidebar--open' : ''}`}>
      <button className="sidebar-close-btn" onClick={onClose} aria-label="Close">
        <X size={16} />
      </button>

      <div className="sidebar-logo">
        <div style={{
          background: '#fff',
          borderRadius: 12,
          padding: '8px 14px',
          display: 'inline-flex',
          alignItems: 'center',
          boxShadow: '0 2px 12px rgba(0,0,0,0.35)',
        }}>
          <img
            src="/hergharlogo.jpeg"
            alt="HerGhar"
            style={{ height: 36, width: 'auto', display: 'block' }}
          />
        </div>
      </div>

      <nav className="sidebar-nav">
        {navItems.map(item => {
          const show = item.section !== lastSection;
          lastSection = item.section;
          return (
            <React.Fragment key={item.to}>
              {show && <div className="nav-section-label">{item.section}</div>}
              <NavLink
                to={item.to}
                className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
                onClick={() => window.innerWidth < 1024 && onClose?.()}
              >
                <item.icon className="nav-icon" />
                <span>{item.label}</span>
              </NavLink>
            </React.Fragment>
          );
        })}
      </nav>

      {/* Sidebar banner */}


      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="avatar" style={{ width: 34, height: 34, fontSize: 13 }}>
            {user?.fullName?.[0] || 'A'}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 12.5, fontWeight: 700, color: 'rgba(255,255,255,0.9)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {user?.fullName || 'Admin'}
            </div>
          </div>
          <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#32CD32', boxShadow: '0 0 6px #32CD32', flexShrink: 0 }} />
        </div>
      </div>
    </aside>
  );
}

Sidebar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};